import { Locale } from '@internal/utils/machine/i18n/Locale'
import { TLocale } from '@internal/utils/machine/i18n/TLocale'
import en from '../../public/locales/en/common.json'
import { convertLanguageJsonToObject } from './translations'

// Create the 'translations' object to provide full intellisense support for the static json files.
convertLanguageJsonToObject(en)

export const localeNames: Record<TLocale, string> = {
  [Locale.de]: 'deutsch',
  [Locale.en]: 'english',
  [Locale.fr]: 'français',
  [Locale.el]: 'ελληνικά',
  [Locale.it]: 'italiano',
  [Locale.pl]: 'polski',
  [Locale.ro]: 'limba română',
  [Locale.ru]: 'Русский язык',
  [Locale.hu]: 'magyar',
  [Locale.es]: 'español',
  [Locale.bg]: 'Български',
  [Locale.sl]: 'slovenskega',
  [Locale.sr]: 'Srpski',
  [Locale.da]: 'Dansk',
  [Locale.cs]: 'Czech',
  [Locale.lt]: 'Lietuvių',
}

export const localeLabels: Record<TLocale, string> = {
  [Locale.de]: 'de',
  [Locale.en]: 'en',
  [Locale.fr]: 'fr',
  [Locale.el]: 'el',
  [Locale.it]: 'it',
  [Locale.pl]: 'pl',
  [Locale.ro]: 'ro',
  [Locale.ru]: 'ru',
  [Locale.hu]: 'hu',
  [Locale.es]: 'es',
  [Locale.bg]: 'bg',
  [Locale.sl]: 'sl',
  [Locale.sr]: 'sr',
  [Locale.da]: 'da',
  [Locale.cs]: 'cz',
  [Locale.lt]: 'lt',
}
